import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../providers/userContext';
import { useAppState } from '../providers/appStateContext';
import { registerSessionRedirect } from '../../services/api/sessionExpiry';

// Lets API interceptors send the user to /login through the router instead of reloading the page.
const SessionExpiryRedirect = () => {
  const navigate = useNavigate();
  const { logout } = useUser();
  const { reset } = useAppState();

  useEffect(() => registerSessionRedirect(() => {
    logout();
    reset();
    navigate('/login', { replace: true });
  }), [logout, reset, navigate]);

  return null;
};

export default SessionExpiryRedirect;
